<div>
  <app-email-modal
    #emailModal
    [meetingBotId]="botId"
    [emails]="emails"
  ></app-email-modal>
  <div class="opportunity-header">
    <div>
      <a [routerLink]="'/dashboard'" class="back-link">
        <i class="fas fa-chevron-left"></i>
        Go back to All Opportunities
      </a>
      <h1 class="opportunity-title">{{ title }}</h1>
    </div>

    <div class="opportunity-header__actions">
      @if (connectedCrmProvider) {
      <button
        type="button"
        class="push-crm-btn"
        [ngClass]="'push-crm-btn--' + connectedCrmProvider"
        [disabled]="!canPushMeetingSummaryToCrm || isCrmPushing"
        [attr.title]="
          !hasCrmMapping
            ? 'Map this opportunity to a CRM record first'
            : 'Push current meeting summary to CRM'
        "
        (click)="pushMeetingSummaryToCrm()"
      >
        <span class="push-crm-btn__icon" aria-hidden="true">
          @if (connectedCrmProvider === 'salesforce') {
          <i class="fa-brands fa-salesforce"></i>
          } @else if (connectedCrmProvider === 'hubspot') {
          <i class="fa-brands fa-hubspot"></i>
          } @else if (connectedCrmProvider === 'zoho') {
          <img
            src="https://www.zoho.com/favicon.ico"
            alt="Zoho"
            class="push-crm-btn__favicon"
          />
          }
          <!-- Pipedrive coming soon — icon branch commented out
          } @else if (connectedCrmProvider === 'pipedrive') {
          <img
            src="https://www.pipedrive.com/favicon.ico"
            alt="Pipedrive"
            class="push-crm-btn__favicon"
          />
          -->
        </span>
        <span class="push-crm-btn__label">
          {{ isCrmPushing ? "Pushing..." : "Push Meeting Summary to CRM" }}
        </span>
      </button>
      }

      <div class="last-updated">
        @if (opportunityDates.length > 0) {
        <div class="date-dropdown" [class.is-open]="isDateDropdownOpen">
          <button
            type="button"
            class="date-dropdown__trigger"
            [attr.aria-expanded]="isDateDropdownOpen"
            aria-label="View previous meeting updates"
            (click)="toggleDateDropdown()"
          >
            <span class="date-dropdown__label">
              {{ lastUpdated | date : "d MMM, y · h:mm a" }}
            </span>
            <i
              class="fas fa-chevron-down date-dropdown__chevron"
              aria-hidden="true"
            ></i>
          </button>

          @if (isDateDropdownOpen) {
          <div
            class="date-dropdown__menu"
            role="menu"
            aria-label="Meeting dates"
          >
            @for (oppDate of opportunityDates; track oppDate?.meeting_bot_id) {
            <button
              type="button"
              class="date-dropdown__option"
              [class.is-active]="oppDate?.meeting_bot_id === botId"
              (click)="switchVersion(oppDate?.meeting_bot_id || '')"
            >
              {{ oppDate.created_at | date : "d MMM, y · h:mm a" }}
            </button>
            }
          </div>
          }
        </div>
        } @else {
        <span class="date-selector-empty">No dates available</span>
        }
      </div>
    </div>
  </div>

  @if (connectedCrmProvider) {
  <section
    class="surface-card crm-mapping-card"
    [ngClass]="'crm-mapping-card--' + connectedCrmProvider"
  >
    <div class="crm-mapping-card__layout">
      <div class="crm-mapping-card__info">
        <h2 class="crm-mapping-card__title">CRM Record Mapping</h2>
        <p class="crm-mapping-card__description">
          Link this opportunity to the matching record in your connected CRM.
        </p>

        @if (hasCrmMapping) {
        <div class="crm-mapping-card__current">
          <span class="crm-mapping-card__current-label">Current Mapping:</span>
          <span class="crm-mapping-card__current-id">{{
            currentCrmMapping?.crm_object_name ||
              currentCrmMapping?.crm_record_id
          }}</span>

          <!-- <pre>{{ currentCrmMapping | json }}</pre> -->
        </div>
        }
      </div>

      <div class="crm-mapping-card__control">
        <span class="crm-mapping-card__provider">{{
          connectedCrmProvider | titlecase
        }}</span>

        <div class="crm-mapping-search">
          @if (isCrmSearchLoading || crmSearchStatusMessage) {
          <div class="crm-mapping-search__state" role="status" aria-live="polite">
            @if (isCrmSearchLoading) {
            <span class="crm-mapping-search__spinner" aria-hidden="true"></span>
            }
            <span class="crm-mapping-search__state-text">{{
              isCrmSearchLoading ? "Searching records..." : crmSearchStatusMessage
            }}</span>
          </div>
          }

          <input
            type="text"
            class="crm-mapping-search__input"
            placeholder="Type at least 3 characters to search CRM records"
            [(ngModel)]="crmSearchTerm"
            (ngModelChange)="onCrmSearchTermChanged()"
            [disabled]="isCrmMapping"
            autocomplete="off"
          />

          @if (crmSearchResults.length > 0) {
          <div
            class="crm-mapping-search__dropdown"
            role="listbox"
            aria-label="CRM search results"
          >
            @for (record of crmSearchResults; track record.id) {
            <button
              type="button"
              class="crm-mapping-search__option"
              (click)="selectCrmRecord(record)"
              [disabled]="isCrmMapping"
            >
              <span class="crm-mapping-search__option-name">{{
                record.name
              }}</span>
              <span class="crm-mapping-search__option-type">{{
                record.type
              }}</span>
            </button>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </section>
  }

  @if (isLoading) {
    <div class="state-container mt-4">
      <div class="spinner"></div>
      <p>Loading meeting details...</p>
    </div>
  } @else if (opportunityDates.length === 0) {
    <div class="state-container mt-4">
      <div class="empty-state-icon">
        <i class="fa-regular fa-calendar-xmark"></i>
      </div>
      <h3>No meetings present</h3>
      <p>Schedule a meeting in your Google Calendar and it will automatically appear here.</p>
    </div>
  } @else {
    <div class="content-wrapper">
    <div class="opportunity-layout">
      <section class="left-pane" #leftCol>
        <article class="surface-card summary-card">
          <header class="summary-card__header">
            <div>
              <h2 class="summary-card__title">Meeting Summary</h2>
              <span *ngIf="lastUpdated" class="summary-card__meta">
                Updated {{ lastUpdated | date : "d MMM, y · h:mm a" }}
              </span>
            </div>
            <div class="summary-card__controls">
              <div
                class="summary-toggle"
                (click)="$event.stopPropagation()"
                [class.summary-toggle--disabled]="!isExtendedSummaryAvailable"
              >
                <button
                  type="button"
                  class="toggle-label"
                  [class.active]="summaryMode === 'short'"
                  [attr.aria-pressed]="summaryMode === 'short'"
                  (click)="onSummaryOptionClick('short', $event)"
                >
                  Short
                </button>
                <button
                  type="button"
                  class="toggle-track"
                  role="switch"
                  [attr.aria-checked]="summaryMode === 'extended'"
                  aria-label="Toggle summary view"
                  [class.extended]="summaryMode === 'extended'"
                  [disabled]="!isExtendedSummaryAvailable"
                  [attr.aria-disabled]="!isExtendedSummaryAvailable"
                  [attr.title]="
                    !isExtendedSummaryAvailable
                      ? extendedSummaryUnavailableCopy
                      : null
                  "
                  (click)="onSummaryToggleClick($event)"
                >
                  <span
                    class="toggle-thumb"
                    [class.extended]="summaryMode === 'extended'"
                  >
                  </span>
                </button>
                <button
                  type="button"
                  class="toggle-label"
                  [class.active]="summaryMode === 'extended'"
                  [attr.aria-pressed]="summaryMode === 'extended'"
                  [disabled]="!isExtendedSummaryAvailable"
                  [attr.title]="
                    !isExtendedSummaryAvailable
                      ? extendedSummaryUnavailableCopy
                      : null
                  "
                  (click)="onSummaryOptionClick('extended', $event)"
                >
                  Long
                </button>
              </div>
            </div>
          </header>

          @if (!isSummaryCollapsed) {
          <div class="summary-card__body">
            <div
              class="formatted-summary"
              [innerHTML]="activeSummaryDetail"
            ></div>

            @if (summaryMode === 'short') {
            <section class="summary-section">
              <header class="summary-section__header">
                <div>
                  <h3 class="summary-section__title">Qualify</h3>
                  <span
                    class="summary-section__meta"
                    *ngIf="answeredQuestions.length"
                  >
                    {{ answeredQuestions.length }} answered ·
                    {{ unansweredQuestions.length }} pending
                  </span>
                </div>
                <button
                  type="button"
                  class="icon-button"
                  [class.active]="isGlobalEditMode"
                  (click)="toggleGlobalEdit()"
                  aria-label="Toggle edit mode"
                >
                  <i class="fas fa-pencil"></i>
                </button>
              </header>

              <div class="question-list">
                @for (opportunityCardDetail of answeredQuestions; track
                opportunityCardDetail.question_id) {
                <div
                  class="question-item"
                  [id]="opportunityCardDetail.question_id"
                >
                  <div class="question-item__prompt">
                    {{ opportunityCardDetail?.question_text ?? "-" }}
                  </div>
                  @if (!isGlobalEditMode) {
                  <div class="question-item__answer">
                    {{ opportunityCardDetail.answers[0].answer_text }}
                  </div>
                  } @else {
                  <textarea
                    [(ngModel)]="editValues[opportunityCardDetail.question_id]"
                    class="question-item__textarea"
                    placeholder="Enter your answer..."
                  ></textarea>
                  }
                </div>
                }
              </div>

              @if (unansweredQuestions.length > 0) {
              <section
                class="unanswered"
                [class.collapsed]="isUnansweredCollapsed"
              >
                <header class="unanswered__header">
                  <button
                    type="button"
                    class="unanswered__trigger"
                    (click)="toggleUnanswered()"
                    [attr.aria-expanded]="!isUnansweredCollapsed"
                  >
                    <span
                      >Unanswered Questions ({{
                        unansweredQuestions.length
                      }})</span
                    >
                    <i class="fas fa-chevron-down"></i>
                  </button>
                </header>
                @if (!isUnansweredCollapsed) {
                <div class="question-list">
                  @for (opportunityCardDetail of unansweredQuestions; track
                  opportunityCardDetail.question_id) {
                  <div
                    class="question-item"
                    [id]="opportunityCardDetail.question_id"
                  >
                    <div class="question-item__prompt">
                      {{ opportunityCardDetail?.question_text ?? "-" }}
                    </div>
                    @if (!isGlobalEditMode) {
                    <div
                      class="question-item__answer question-item__answer--empty"
                    >
                      No answer provided yet
                    </div>
                    } @else {
                    <textarea
                      [(ngModel)]="
                        editValues[opportunityCardDetail.question_id]
                      "
                      class="question-item__textarea"
                      placeholder="Enter your answer..."
                    ></textarea>
                    }
                  </div>
                  }
                </div>
                }
              </section>
              } @if (isGlobalEditMode) {
              <footer class="card-actions">
                <button class="btn btn-primary" (click)="saveAllAnswers()">
                  Save All Answers
                </button>
                <button class="btn btn-secondary" (click)="cancelEdit()">
                  Cancel
                </button>
              </footer>
              }
            </section>
            }

            <section class="summary-section">
              <header
                class="summary-section__header summary-section__header--sub"
              >
                <h3 class="summary-section__title">Next Steps</h3>
              </header>
              @if (nextStepGroups.length) {
              <div class="next-steps">
                @for (group of nextStepGroups; track $index) {
                <div class="next-steps__group">
                  @if (group.heading) {
                  <h4 class="next-steps__group-title">{{ group.heading }}</h4>
                  } @if (group.items.length) {
                  <ul class="next-steps__list">
                    @for (item of group.items; track $index) {
                    <li [innerHTML]="item"></li>
                    }
                  </ul>
                  }
                </div>
                }
              </div>
              } @else {
              <div class="next-steps__empty">--</div>
              }
            </section>

            <button type="button" class="email-btn" (click)="openEmailPopup()">
              Email
            </button>
          </div>
          }
        </article>
      </section>

      <aside class="right-pane" #rightPane>
        @if (recordingUrl) {
        <div class="meeting-video">
          <button
            type="button"
            class="video-download-btn"
            (click)="downloadRecording()"
            title="Download meeting video"
            aria-label="Download meeting video"
          >
            <i class="fas fa-download"></i>
          </button>
          <video
            #videoPlayer
            controls
            controlsList="nodownload"
            preload="metadata"
            (play)="onVideoPlay()"
            (pause)="onVideoPause()"
            (loadstart)="onVideoLoadStart()"
            (canplay)="onVideoCanPlay()"
            (loadeddata)="onVideoLoadedData()"
          >
            <source [src]="recordingUrl" type="video/mp4" />
            <source [src]="recordingUrl" type="video/webm" />
            <source [src]="recordingUrl" type="video/mov" />
            Your browser does not support the video tag.
          </video>
          <div class="media-loading" *ngIf="isVideoLoading">
            <div class="media-loading__logo"></div>
            <div class="media-loading__text">Loading video...</div>
          </div>
        </div>
        } @else {
        <div class="meeting-video meeting-video--empty">
          <i class="fas fa-video-slash"></i>
          <p>No recording available for this meeting</p>
          <small
            >Recording may not have been enabled or is still processing</small
          >
        </div>
        }

        <div
          class="surface-card transcript-card"
          [class.collapsed]="isTranscriptCollapsed"
        >
          <header class="card-section__header">
            <span class="card-section__title">Transcript</span>
            <div class="transcript-header-actions">
              <button
                type="button"
                class="copy-transcript-btn"
                [class.copied]="isTranscriptCopied"
                (click)="copyTranscript()"
                [title]="isTranscriptCopied ? 'Copied!' : 'Copy transcript'"
                [attr.aria-label]="
                  isTranscriptCopied
                    ? 'Copied to clipboard'
                    : 'Copy transcript to clipboard'
                "
              >
                <fa-icon
                  *ngIf="!isTranscriptCopied"
                  [icon]="copyIcon"
                  [fixedWidth]="true"
                  class="copy-transcript-icon"
                  aria-hidden="true"
                ></fa-icon>
                <fa-icon
                  *ngIf="isTranscriptCopied"
                  [icon]="checkIcon"
                  [fixedWidth]="true"
                  class="copy-transcript-icon checkmark"
                  aria-hidden="true"
                ></fa-icon>
              </button>
              <button
                type="button"
                class="collapse-btn"
                [class.is-open]="!isTranscriptCollapsed"
                [attr.aria-expanded]="!isTranscriptCollapsed"
                [attr.aria-label]="
                  isTranscriptCollapsed
                    ? 'Expand transcript section'
                    : 'Collapse transcript section'
                "
                (click)="toggleTranscript()"
              >
                <i class="fas fa-chevron-down"></i>
              </button>
            </div>
          </header>
          @if (!isTranscriptCollapsed) {
          <div class="transcript-card__body" #rightScroll>
            <div
              class="transcript-entry"
              *ngFor="let item of meetingTranscripts"
            >
              <span class="transcript-speaker">{{ item.speaker }}:</span>
              <span>{{ item.transcript }}</span>
            </div>
          </div>
          }
        </div>
      </aside>
    </div>
  </div>
  }
</div>
